export class LanguageFlyout {
    constructor() {
        $('#msLangNav').on('click, focus', function () {
            $('#msLangNav').addClass('active');
        });
        $('#msLangNav.active').on('click', function () {
            $('#msLangNav').removeClass('active');
        });
        $('#msLangNav').on('mouseleave', function () {
            $('#msLangNav').removeClass('active');
        });
    }
}